<template>
  <div
    class="custom-row-table d-flex justify-content-center align-items-center"
  >
    <div
      :id="'button-' + certificate.id"
      class="w-100 d-flex justify-content-center align-items-center"
    >
      <b-form-checkbox
        size="lg"
        class="w-100"
        switch
        v-model="certificate.allowLink"
        @click.native.prevent="onUpdateLinkCertificateClick(certificate)"
        >{{ certificate.allowLink ? "Sim" : "Não" }}</b-form-checkbox
      >
    </div>
    <attention-modal
      modalId="link-certificate-attention-modal"
      title="Atenção!"
      submitButtonText="Sim"
      cancelButtonText="Não tenho certeza"
      ref="link-certificate-attention-modal"
      :onAction="this.onLinkCertificateConfirm"
    >
      <template slot="description">
        <p class="p1 mb-5 text-center">
          Você tem certeza de que deseja {{ optionText }} vínculos para este
          certificado?
        </p>
      </template>
    </attention-modal>
  </div>
</template>
<script>
import AttentionModal from "../../../components/base-modals/AttentionModal.vue";

export default {
  name: "activation-toogle",
  components: {
    AttentionModal,
  },
  data() {
    return {
      optionText: "",
    };
  },
  props: ["certificate", "showConfirmationModal"],
  mounted() {
    this.optionText = this.certificate.allowLink ? "impedir" : "permitir";
  },
  methods: {
    onUpdateLinkCertificateClick() {
      if (!this.showConfirmationModal) {
        this.$emit("onUpdateLinkCertificateClick", this.certificate);
        return;
      }
      const modal = this.$refs["link-certificate-attention-modal"].$children[0];
      modal.show();
    },
    async onLinkCertificateConfirm(confirmed) {
      if (!confirmed) {
        return;
      }
      this.$emit("onUpdateLinkCertificateClick", this.certificate);
    },
  },
};
</script>
